export default {
   SET_BENEFIT_PAGINATION_INFO: (state, info) => {
      state.benefits.pagination.totalPages = info.totalPages
      state.benefits.pagination.tokenPages = info.tokenPages
   },

   SET_ALL_BENEFITS: (state, allBenefits) => {
      state.benefits.allBenefits = allBenefits;
   },

   SET_BENEFITS: (state, benefits) => {
      state.benefits.data = benefits.data;
   },

   SET_BENEFIT_CURRENT_PAGE: (state, currentPage) => {
      state.benefits.pagination.currentPage = currentPage
   },

   SET_BENEFIT_LOADING: (state, loading) => {
      state.benefits.loading = loading
   }
}
